export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4.5 2c-1.1 0-2 .9-2 2v13h2V4h12V2zm4 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14V8h11v12z\"/>"
};